<template>
  <div :class="['pls-card', 'card d-flex', 'flex-column', 'w-100', 'mt-2', 'h-100']">
    <div class="card-img-top aspect-ratio-4-3 crc-img-container cover br-tl-4 br-tr-4 position-relative pls-skeleton-block pls-skeleton-image">
      <svg class="pls-skeleton-image-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="4" width="20" height="16" rx="1.5" stroke="currentColor" stroke-width="1.4"/>
        <circle cx="8" cy="9.5" r="1.75" stroke="currentColor" stroke-width="1.4"/>
        <path d="M3 16.5L8.5 12L12.5 15L16.5 11L21 15.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="px-3 px-md-4 px-lg-4 py-3 card-body d-flex flex-column">
      <div class="pls-skeleton-block pls-skeleton-bar pls-skeleton-title"></div>
      <div class="pls-skeleton-block pls-skeleton-bar pls-skeleton-version"></div>
      <div class="flex-wrap mt-0 card-usps d-flex">
        <span class="me-2 pls-skeleton-block pls-skeleton-pill"></span>
        <span class="me-2 pls-skeleton-block pls-skeleton-pill"></span>
      </div>
      <div class="mt-4 pls-card-price-container d-flex justify-content-between align-items-center">
        <div class="pls-skeleton-block pls-skeleton-bar pls-skeleton-price"></div>
      </div>
      <div class="pls-divider"></div>
      <div class="flex-wrap mt-1 pls-card-dealer-info d-flex flex-column text-wrap">
        <div class="pls-skeleton-block pls-skeleton-bar pls-skeleton-dealer-info"></div>
      </div>
      <div class="pls-card-action-btn-wrapper">
        <div class="pls-skeleton-block pls-skeleton-btn"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonCarCard',
}
</script>

<style scoped>
.pls-skeleton-block {
  background-color: #d9dcde;
  background-image: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.9) 50%, transparent 100%);
  background-repeat: no-repeat;
  background-size: 60% 100%;
  background-position: -60% 0;
  animation: pls-skeleton-shimmer 1.3s linear infinite;
  border-radius: 4px;
}

@keyframes pls-skeleton-shimmer {
  0% {
    background-position: -60% 0;
  }
  100% {
    background-position: 160% 0;
  }
}

.pls-skeleton-image {
  width: 100%;
  aspect-ratio: 4 / 3;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pls-skeleton-image-icon {
  width: 25%;
  height: 25%;
  color: #b9bdc1;
}

.pls-skeleton-bar {
  height: 14px;
  margin-bottom: 0.75rem;
}

.pls-skeleton-title {
  width: 70%;
  height: 18px;
}

.pls-skeleton-version {
  width: 90%;
}

.pls-skeleton-pill {
  width: 60px;
  height: 22px;
  border-radius: 50rem;
}

.pls-skeleton-price {
  width: 40%;
  height: 18px;
}

.pls-skeleton-dealer-info {
  width: 100%;
}

.pls-skeleton-btn {
  width: 100%;
  height: 38px;
  border-radius: 50rem;
}
</style>
